export function isAndroidDevice(): boolean {
  return /Android/i.test(navigator.userAgent);
}

export function isIosDevice(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isTouchDevice(): boolean {
  return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/i.test(
    navigator.userAgent
  );
}

//with an inner width of less than 705 it is probably a mobile phone on m.bild.de
//705 is the desktop size of the text area on bild.de
export function isMobilePhone(): boolean {
  return window.innerWidth < 450;
}

export function inIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
